import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '@core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AnalyticsModule } from './modules/analytics/analytics.module';
import { AdminComponent } from './admin/admin.component';
import { EditNotificationModalComponent } from './admin/notifications/edit-notification-modal/edit-notification-modal.component';
import { NotificationModalComponent } from './admin/notifications/notification-modal/notification-modal.component';
import { NotificationsComponent } from './admin/notifications/notifications.component';
import { AddUserModalComponent } from './admin/users/add-user-modal/add-user-modal.component';
import { UsersComponent } from './admin/users/users.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
// import { AdminRoutingModule } from './admin/admin-routing.module';

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    UsersComponent,
    AddUserModalComponent,
    NotificationsComponent,
    EditNotificationModalComponent,
    NotificationModalComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule.forRoot(),
    AppRoutingModule,
    AnalyticsModule,
    CommonModule,
    SharedModule,
    // AdminRoutingModule,
    ReactiveFormsModule,
    BsDropdownModule,
    TooltipModule,
    TypeaheadModule,
    BsDatepickerModule,
    CKEditorModule,
    TranslateModule,
    ModalModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
